import request from '@/utils/request'

// getShipList
export function getShipList(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6400/getShipList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getBlkList
export function getBlkList(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6400/getBlkList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getSetPointList
export function getSetPointList(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6400/getSetPointList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getRevNo
export function getRevNo(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6400/getRevNo`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epms6400List
export function epms6400List(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6400/epms6400List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epms6400Xls
export function epms6400Xls(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6400/epms6400Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms6400Xls RES', res)

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `Cable Installation Area List.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}